import { useCallback, useMemo } from "react";
import { SingleValueQSMapper, useNavigateQuery, useSingleQueryParams } from "./url";

export type IQueryState<TKey extends string> = Record<TKey, string>;
export type IQuerySearch = IQueryState<"search">;

export function useQuerySearch(): [string, (val: string) => void] {
    return useQueryState("search");
}

export function useQueryState<TKey extends string>(key: TKey): [string, (val: string) => void] {
    const params = useSingleQueryParams<IQueryState<TKey>>({
        [key]: (raw: string) => raw
    } as SingleValueQSMapper<IQueryState<TKey>>);
    const search = params[key];
    const setSearchRaw = useNavigateQuery<IQueryState<TKey>>();

    const setSearch = useCallback((val: string) => {
        if (val !== search) {
            setSearchRaw({
                [key]: val
            } as Partial<IQueryState<TKey>>);
        }
    }, [search, setSearchRaw, key]);

    return useMemo(() => [search, setSearch], [search, setSearch]);
}
